
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class PaperSteps extends Vue {
  @Prop({ default: 1, type: Number }) private active!: number;
  @Prop({ default: "", type: String }) private type!: string;
  @Prop({
    default: () => {
      return [];
    },
    type: Array
  })
  private finishList!: [];
  get list() {
    return ["面试设置", "背调设置", "编辑题目", "创建完成"];
  }
}
